import { useState, useCallback } from "react";
import type { FormData, SlidesStep } from "../types";

const INITIAL_FORM_DATA: FormData = {
  title: "",
  subject: "",
  topic: "",
  audience: "Estudantes",
  slideStyle: "educational",
  colorScheme: "blue",
  slideCount: "15",
  includeImages: true,
  includeDiagrams: true,
  includeExamples: true,
  includeSummary: true,
  customInstructions: "",
};

export function useSlidesForm() {
  const [step, setStep] = useState<SlidesStep>("form");
  const [formData, setFormData] = useState<FormData>(INITIAL_FORM_DATA);

  const updateFormData = useCallback((field: keyof FormData, value: any) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const resetForm = useCallback(() => {
    setFormData(INITIAL_FORM_DATA);
  }, []);

  const setInitialData = useCallback((data: Partial<FormData>) => {
    setFormData((prev) => ({ ...prev, ...data }));
  }, []);

  return {
    step,
    setStep,
    formData,
    updateFormData,
    resetForm,
    setInitialData,
  };
}
